import React from "react";
import _ from "lodash";
import UIActions from "../../actions/UIActions";
import AppConstants from "../../constants/AppConstants";

class ModalController {
  getModal(parent, modalName, modal, modalComponentName) {
    let component = null;
    if (modal) {
      let isShowing = true;
      const modalState = modal.get("state");
      if (AppConstants.MODAL_STATE_INACTIVE == modalState) {
        return component;
      }

      if (AppConstants.MODAL_STATE_CLOSED == modalState) {
        isShowing = false;
      }

      let props = {
        show: isShowing,
        onHide: function () {
          UIActions.modalClose(modalName);
        },
        onExited: function () {
          UIActions.modalDeactivate(modalName);
        },
        container: parent,
        key: modalName,
      };

      const modalData = modal.get("data", false);
      if (modalData) {
        props = _.merge(props, modalData);
      }

      component = React.createElement(modalComponentName, props);
    }

    return component;
  }
}

export default new ModalController();
